<template>
  <div>
    <el-carousel height="49.37rem" autoplay>
      <el-carousel-item v-for="(image, index) in pageImageList" :key="index">
        <img class="page_dev_img" :src="require(`@/assets/${image}`)" :alt="'Image ' + (index + 1)" />
      </el-carousel-item>
    </el-carousel>
    <div>
        <div class="page_b2b">
       <div class="page_b2b_flex">
        <div class="page_b2b_b">
          <div class="page_b2b_title">订单管理</div>
          <div class="page_b2b_text">订单管理文案/订单管理文案/订单管理文案/订单管理文案订单管理文案/订单管理文案/订单管理文案订单管理文案/订单管理文案/订单管理文案订单管理文案/订单管理文案/订单管理文案订单管理文案/订单管理文案/订单管理文案订单管理文案/订单管理文案/订单管理文案订单管理文案/订单管理文案/订单管理文案</div>
        </div> 
        <div class="page_b2b_c">
          <img class="page_b2b_c_img" src="../assets/pinpai2.png" />
        </div>
       </div>
       <div class="page_b2b_flex">
        <div class="page_b2b_c">
          <img class="page_b2b_c_img" src="../assets/pinpai3.png" />
        </div>
        <div class="page_b2b_b">
          <div class="page_b2b_title">数据分析</div>
          <div class="page_b2b_text">数据分析文案/数据分析文案/数据分析文案数据分析文案/数据分析文案/数据分析文案数据分析文案/数据分析文案/数据分析文案数据分析文案/数据分析文案/数据分析文案数据分析文案/数据分析文案/数据分析文案数据分析文案/数据分析文案/数据分析文案</div>
        </div> 
       </div>
       <div class="page_b2b_flex">
        <div class="page_b2b_b">
          <div class="page_b2b_title">自动化系统</div>
          <div class="page_b2b_text">自动化系统文案/自动化系统文案/自动化系自动化系统文案/自动化系统文案/自动化系自动化系统文案/自动化系统文案/自动化系自动化系统文案/自动化系统文案/自动化系自动化系统文案/自动化系统文案/自动化系</div>
        </div> 
        <div class="page_b2b_c">
          <img class="page_b2b_c_img" src="../assets/pinpai2.png" />
        </div>
       </div>
    </div>
    </div>
    <div class="page_xx">
        <div class="page_x_text">
            XXXXXXX
        </div>
        <div class="page_x_flex">
            <div style="text-align: center;">
                <div class="page_x_did">XXXX</div>
                <div class="page_x_num">交易数量</div>
            </div>
            <div style="text-align: center;">
                <div class="page_x_did">XXXX</div>
                <div class="page_x_num">合作品牌</div>
            </div>
            <div style="text-align: center;">
                <div class="page_x_did">XXXX</div>
                <div class="page_x_num">新增客户量</div>
            </div>
            <div style="text-align: center;">
                <div class="page_x_did">XXXX</div>
                <div class="page_x_num">订单增长比例</div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
export default {
    data() {
    return {
      pageImageList: ["lunbo.png", "lunbo.png", "lunbo.png", "lunbo.png"],
    }
   }
}
</script>

<style scoped>
.page_dev_img {
  width: 100%;
  height: 49.37rem;
  object-fit: cover;
}
.page_b2b{
  padding: 6.875rem 5rem;
  padding-bottom: 5rem;
  
}
.page_b2b_flex{
  margin-bottom: 5rem;
  display: flex;
  justify-content: space-between;
}
.page_b2b_flex2{
  display: flex;
  justify-content: space-between;
}
.page_b2b_b{
  width: 50%;
}
.page_b2b_c{
  width: 43%;
}
.page_b2b_c_img{
  width: 35rem;
  height: 36.25rem;
  object-fit: cover;

}
.page_b2b_title{
  color: #222222;
  font-size: 3.125rem;
  line-height: 3.125rem;
  margin-bottom: 2rem;
  margin-top: 5rem;
}
.page_b2b_text{
  color: #222222;
  font-size: 1.75rem;
  line-height: 3.25rem;
}

.page_xx{
    padding: 0 5rem;
}
.page_x_text{
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 3.125rem 0;
    font-size: 3.125rem;
    color: #131316;
    border-top: 0.2rem solid #D8D8D8;
    border-bottom:0.2rem solid #D8D8D8 ;
}
.page_x_flex{
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 7rem;
    margin-top: 7rem;
}
.page_x_did{
color: #131316;
font-size: 6.25rem;
}
.page_x_num{
color: #131316;
font-size: 1.625rem;
line-height: 3.125rem;
}
</style>